const all_1 = 2;
const first_1 = all_1 - 1;

const all_2 = 3;
const fist_2 = all_2 - 1;

const firstLast = {
  all: all_1,
  first: first_1,
  isFullAll: false,
  isFullFirst: false,
  people: { first: [], follow: [] },
};
const middle = {
  all: all_2,
  first: fist_2,
  isFullAll: false,
  isFullFirst: false,
  people: { first: [], follow: [] },
};
const onsite = {
  all: 100,
  first: 100,
  isFullAll: false,
  isFullFirst: false,
  people: { first: [], follow: [] },
};
let doctor = "李如浩";
const hours = {
  早診: {
    doctor: doctor,
    show: false,
    isFullAll: false,
    isFullFirst: false,
    "09:00-09:30": Object.assign({}, firstLast),
    "09:30-10:00": Object.assign({}, middle),
    "10:00-10:30": Object.assign({}, middle),
    "10:30-11:00": Object.assign({}, firstLast),
    "11:00-11:30": Object.assign({}, middle),
    "11:30-11:50": Object.assign({}, firstLast),
    onsite: Object.assign({}, onsite),
  },
  午診: {
    doctor: doctor,
    show: false,
    isFullAll: false,
    isFullFirst: false,
    "15:00-15:30": Object.assign({}, firstLast),
    "15:30-16:00": Object.assign({}, middle),
    "16:00-16:30": Object.assign({}, middle),
    "16:30-17:00": Object.assign({}, firstLast),
    "17:00-17:30": Object.assign({}, middle),
    "17:30-17:50": Object.assign({}, firstLast),
    onsite: Object.assign({}, onsite),
  },
  晚診: {
    doctor: doctor,
    show: false,
    isFullAll: false,
    isFullFirst: false,
    "18:00-18:30": Object.assign({}, firstLast),
    "18:30-19:00": Object.assign({}, middle),
    "19:00-19:30": Object.assign({}, middle),
    "19:30-20:00": Object.assign({}, firstLast),
    "20:00-20:30": Object.assign({}, middle),
    "20:30-20:50": Object.assign({}, firstLast),
    onsite: Object.assign({}, onsite),
  },
};

export const openTime = {
  hansheng: {
    週日: [],
    週一: [],
    週二: ["晚診"],
    週三: [],
    週四: ["晚診"],
    週五: ["午診", "晚診"],
    週六: ["早診"],
  },
  yoyo: {
    週日: [],
    週一: [],
    週二: [],
    週三: ["午診", "晚診"],
    週四: [],
    週五: [],
    週六: [],
  },
};

function generateFutureDaysWithWeeks(startDate, numberOfWeeks, pastWeeks = 0) {
  const daysOfWeek = ["週日", "週一", "週二", "週三", "週四", "週五", "週六"];
  let dates = {};

  // config.getUTC8Time() 回傳的 Date 物件，其 UTC 年月日就是台灣的年月日
  // 必須全程用 getUTC* 系列，避免因執行環境時區不同而偏移
  const startYear = startDate.getUTCFullYear();
  const startMonth = startDate.getUTCMonth();
  const startDay = startDate.getUTCDate();

  // 以 UTC 午夜建立起始點，確保 getUTCDay() 等計算不受時間影響
  let currentDate = new Date(Date.UTC(startYear, startMonth, startDay));
  currentDate.setUTCDate(currentDate.getUTCDate() - pastWeeks * 7);

  for (let i = 0; i < (numberOfWeeks + pastWeeks) * 7; i++) {
    let year = currentDate.getUTCFullYear();
    let month = String(currentDate.getUTCMonth() + 1).padStart(2, "0");
    let day = String(currentDate.getUTCDate()).padStart(2, "0");
    let dateStr = `${year}-${month}-${day}`;
    dates[dateStr] = { week: daysOfWeek[currentDate.getUTCDay()] };
    currentDate.setUTCDate(currentDate.getUTCDate() + 1);
  }

  return dates;
}

export const ondays = (startDate, numberOfWeeks, clinic_name, pastWeeks = 0) => {
  // 參數驗證
  if (!startDate || !numberOfWeeks || !clinic_name) {
    console.error("ondays 函數參數錯誤:", {
      startDate,
      numberOfWeeks,
      clinic_name,
    });
    throw new Error("ondays 函數缺少必要參數");
  }

  // 驗證 clinic_name 是否有效
  if (!openTime[clinic_name] && clinic_name !== "all") {
    console.error("無效的診所名稱:", clinic_name);
    throw new Error(`不支援的診所名稱: ${clinic_name}`);
  }

  let futureDaysObject = generateFutureDaysWithWeeks(
    startDate,
    numberOfWeeks,
    pastWeeks,
  );

  Object.keys(futureDaysObject).forEach((date) => {
    futureDaysObject[date].hours = JSON.parse(JSON.stringify(hours));

    if (clinic_name === "all") {
      // 處理所有診所的情況
      if (openTime.hansheng[futureDaysObject[date].week]) {
        openTime.hansheng[futureDaysObject[date].week].forEach((time) => {
          if (futureDaysObject[date].hours[time]) {
            futureDaysObject[date].hours[time].show = true;
          }
        });
      }

      if (openTime.yoyo[futureDaysObject[date].week]) {
        openTime.yoyo[futureDaysObject[date].week].forEach((time) => {
          if (futureDaysObject[date].hours[time]) {
            futureDaysObject[date].hours[time].show = true;
          }
        });
      }
    } else {
      // 處理單一診所的情況
      const clinicSchedule = openTime[clinic_name];
      const weekSchedule = clinicSchedule[futureDaysObject[date].week];

      if (weekSchedule && Array.isArray(weekSchedule)) {
        weekSchedule.forEach((time) => {
          if (futureDaysObject[date].hours[time]) {
            futureDaysObject[date].hours[time].show = true;
          }
        });
      }
    }
  });

  return futureDaysObject;
};

//sortData: {2024-07-19: {…}, 2024-08-01: {…}, 2024-10-03: {…}, 2024-10-09: {…}, 2024-10-11: {…}, …}
